/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-slack': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5.651 11.979a1.576 1.576 0 11-1.575-1.576h1.575v1.576zm.795 0a1.576 1.576 0 113.15 0v3.945a1.576 1.576 0 11-3.15 0V11.98zM8.02 5.65a1.576 1.576 0 111.576-1.575V5.65H8.02zm0 .795a1.576 1.576 0 110 3.15H4.075a1.576 1.576 0 110-3.15h3.946zm6.33 1.575a1.576 1.576 0 111.575 1.576H14.35V8.02zm-.795 0a1.576 1.576 0 11-3.15 0V4.075a1.576 1.576 0 113.15 0v3.946zm-1.575 6.33a1.576 1.576 0 11-1.576 1.575V14.35h1.576zm0-.795a1.576 1.576 0 110-3.15h3.945a1.576 1.576 0 110 3.15H11.98z"/>'
  }
})
